import CircularProgress from "@mui/material/CircularProgress";

type Props = {
  className?: string;
  classNameWrapper?: string;
  color?: string;
  size?: number | string;
};

const Spinner: React.FC<Props> = (props: Props) => {
  return (
    <div className={`${props.classNameWrapper ?? "flex flex-row justify-center w-full"}`}>
      <div className={props.className}>
        <CircularProgress
          sx={{
            color: props.color || 'primary',
          }}
          size={props.size || 40}
        />
      </div>
    </div>
  );
};

export default Spinner;
